export default __webpack_public_path__ + "static/spendenscheckuebergabe-e4e3750490705fdeff4c75adeddf2661.jpg";